import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class TranslateConfigService {
  // Language switching is disabled; the app always runs in English.
  public static readonly DEFAULT_LANG = 'en';
  currentLanguage: any = TranslateConfigService.DEFAULT_LANG;

  constructor(private translate: TranslateService) {}

  public  getDefaultLanguage() {
    // this.translate.currentLang
    const lang = TranslateConfigService.DEFAULT_LANG;
    this.currentLanguage = lang;
    localStorage.setItem('lang', lang);
    this.translate.setDefaultLang(lang);
    this.translate.use(lang);
    return lang;
    // if (this.currentLang) {
    //   this.translate.setDefaultLang(this.currentLang);
    // } else {
    //   localStorage.setItem('lang', this.translate.getBrowserLang()!);
    //   this.currentLang = this.translate.getBrowserLang();
    //   this.translate.setDefaultLang(this.currentLang);
    // }
    //  return this.currentLang;
  }

  public setLanguage(_setLang?: string) {
    // Ignore requested language and keep English
    this.getDefaultLanguage();
  }

  public getCurrentLang() {
    return TranslateConfigService.DEFAULT_LANG;
  }
}
